var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ol',_vm._l((_vm.displayed),function(crumb,index){return _c('li',{key:index,attrs:{"title":_vm.fullPath,"aria-label":_vm.fullPath}},[(!crumb.to || index === (_vm.displayed.length - 1))?_c('span',[_vm._v(_vm._s(crumb.label))]):_c('router-link',{attrs:{"to":crumb.to}},[_vm._v(_vm._s(crumb.label))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }